import { Spinner } from '@/components/ui/spinner';

/**
 * The gallery's loading state, labelled for assistive tech. Its own module so
 * App.tsx can use it as the lazy route's Suspense fallback without pulling the
 * page chunk into the main bundle.
 */
const GalleryLoading = () => (
  <main
    className="flex min-h-dvh items-center justify-center bg-background"
    aria-busy="true"
    aria-label="Loading PlanOtour"
  >
    <Spinner size="lg" aria-label="Loading PlanOtour" />
  </main>
);

export default GalleryLoading;
